export enum LANG { jp = 1, en };

export type Language = LANG.jp | LANG.en; // 'jp' | 'en';
